import { RANGE_PRESETS, utcDay } from './range';
import './statistics.css';

const REFRESH_PRESETS = [
  { label: '30s', seconds: 30 },
  { label: '1m', seconds: 60 },
  { label: '5m', seconds: 300 },
  { label: 'off', seconds: 0 },
];

/**
 * The page's one filter row.
 *
 * Everything below it is scoped by this, so every chart and stat agrees. It
 * replaces three separate mental models of "when": PerfCharts' 15m-7d pills,
 * Statistics' hard-coded DAILY_DAYS = 14, and History's date picker.
 *
 * Date range first — it is the control readers reach for. Auto-refresh sits at
 * the far right because it only drives the live-health section; putting a
 * 90-day daily rollup on a 30-second timer is pure waste.
 */
function RangeControl({
  receivers = [],
  receiverUuid,
  onReceiverChange,
  range,                 // { preset, date }
  onRangeChange,
  refreshSeconds,
  onRefreshChange,
  onRefreshNow,
  loading = false,
  updatedAt = null,
}) {
  const today = utcDay(new Date());

  const pickPreset = (id) => onRangeChange({ preset: id, date: null });
  const pickDate = (e) => {
    const v = e.target.value;
    onRangeChange(v ? { preset: 'date', date: v } : { preset: '7d', date: null });
  };

  return (
    <div className="stats-filter-row">
      <div className="stats-filter-group">
        <span className="stats-filter-label">Receiver</span>
        <select
          className="stats-select"
          value={receiverUuid || ''}
          onChange={onReceiverChange}
        >
          {receivers.length === 0 && <option value="">No receivers</option>}
          {receivers.map(r => (
            <option key={r.receiverUuid} value={r.receiverUuid}>
              {r.receiverName || r.displayName}
            </option>
          ))}
        </select>
      </div>

      <div className="stats-filter-group">
        <span className="stats-filter-label">Range</span>
        {RANGE_PRESETS.map(p => (
          <button
            key={p.id}
            type="button"
            className={`stats-pill${range.preset === p.id && !range.date ? ' active' : ''}`}
            onClick={() => pickPreset(p.id)}
          >{p.label}</button>
        ))}
        <input
          type="date"
          className={`stats-date${range.date ? ' active' : ''}`}
          value={range.date || ''}
          max={today}
          onChange={pickDate}
          aria-label="Specific day"
        />
      </div>

      <div className="stats-filter-group stats-filter-right">
        <span className="stats-filter-label">Live refresh</span>
        {REFRESH_PRESETS.map(r => (
          <button
            key={r.label}
            type="button"
            className={`stats-pill${refreshSeconds === r.seconds ? ' active' : ''}`}
            onClick={() => onRefreshChange(r.seconds)}
          >{r.label}</button>
        ))}
        <button
          type="button"
          className="stats-pill stats-pill-action"
          onClick={onRefreshNow}
          disabled={loading || !receiverUuid}
        >{loading ? 'Loading…' : 'Refresh'}</button>
        {updatedAt && (
          <span className="stats-filter-meta">
            {updatedAt.toLocaleTimeString()}
          </span>
        )}
      </div>
    </div>
  );
}

export default RangeControl;
